import * as gamesConst from "../const/games.const";

const initialState = {
  game: [],
  twoRandomGames: [],
  gameImages: [],
  isLoading: false
};

const gameInfo = (state = initialState, action) => {
  switch (action.type) {

    // GET_GAMES

    case gamesConst.GET_GAMES:
      return { ...state, game: action.payload };

    case gamesConst.GET_GAMES_FULFILLED:
      return { ...state, game: action.payload.data, isLoading: false };

    case gamesConst.GET_GAMES_PENDING:
      return { ...state, isLoading: true };

    case gamesConst.GET_GAMES_REJECTED:
      return { ...state };

    // GET_RANDOM_GAMES

    case gamesConst.GET_R_GAMES:
      return { ...state, twoRandomGames: action.payload };

    case gamesConst.GET_R_GAMES_FULFILLED:
      return { ...state, twoRandomGames: action.payload.data, isLoading: false };

    case gamesConst.GET_R_GAMES_PENDING:
      return { ...state, isLoading: true };

    case gamesConst.GET_R_GAMES_REJECTED:
      return { ...state };

    // GET_GAME_IMAGES

    case gamesConst.GET_GAME_IMAGES:
      return { ...state, gameImages: action.payload };

    case gamesConst.GET_GAME_IMAGES_FULFILLED:
      return { ...state, gameImages: action.payload.data, isLoading: false };

    case gamesConst.GET_GAME_IMAGES_PENDING:
      return { ...state, isLoading: true };

    case gamesConst.GET_GAME_IMAGES_REJECTED:
      return { ...state };

    // DEFAULT

    default:
      return state;
  }
}

export default gameInfo;